import { Link } from "react-router-dom";
import { manageQueriesIcon, noQueries } from "../../asset";
import { QueryItem } from "../../types/Query";
// import { manageQueriesData } from "../../util/Constants";

interface ManageQueriesProps {
  queries?: QueryItem[];
}

export default function ManageQueries({ queries = [] }: ManageQueriesProps) {
  return (
    <div className="bg-white rounded-2xl shadow-[0_0_54px_0_rgba(0,0,0,0.05)] p-3">
      {/* Header */}
      <div className="flex justify-between items-center gap-4">
        <div className="flex gap-3 items-center">
          <img
            src={manageQueriesIcon}
            alt="Upcoming Events"
            className="w-8 h-8"
          />
          <p className="text-base text-neutral-500 font-medium text-nowrap">
            Manage Queries
          </p>
        </div>
        {queries.length > 0 && (
          <Link
            to="/queries"
            className="underline text-sm text-primary-600 font-medium"
          >
            View All
          </Link>
        )}
      </div>

      {/* Empty State */}
      {queries.length === 0 ? (
        <div className="flex flex-col gap-4 pt-5 pb-2 justify-center items-center h-[300px]">
          <img
            src={noQueries}
            alt="no queries"
            className="w-10 h-10 border-2 rounded-full p-2 border-neutral-200"
          />
          <div className="flex flex-col gap-2">
            <p className="text-neutral-300 text-base font-medium text-center underline">
              All caught up!
            </p>
            <p className="text-[13px] font-normal text-neutral-300">
              No pending queries at the moment.
            </p>
          </div>
        </div>
      ) : (
        <div className="pt-4 flex flex-col h-[370px] overflow-y-auto custom-scrollbar px-5">
          {queries?.map((items, i) => (
            <div
              key={i}
              className="flex items-center gap-[10px] border-b border-neutral-50 last:border-none py-[14px]"
            >
              {items?.motherPhoto ? (
                <img
                  src={items.motherPhoto}
                  alt="profile"
                  className="w-11 h-11 rounded-full object-cover"
                />
              ) : items?.fatherPhoto ? (
                <img
                  src={items.fatherPhoto}
                  alt="profile"
                  className="w-11 h-11 rounded-full object-cover"
                />
              ) : (
                <div className="w-11 h-11 shrink-0 rounded-full bg-primary-400 flex items-center justify-center text-white font-semibold text-lg">
                  {(
                    items?.motherName?.charAt(0) ||
                    items?.fatherName?.charAt(0) ||
                    "?"
                  ).toUpperCase()}
                </div>
              )}

              <div className="flex flex-col">
                <p className="text-[15px] text-neutral-400">
                  You have a query from{" "}
                  <span className="font-semibold">
                    {items?.motherName || items?.fatherName}
                  </span>
                  .
                </p>
                <Link
                  to={`/queries/view-query/${items.id}`}
                  className="text-neutral-300 text-xs"
                >
                  Click to view
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
